module.exports = __webpack_public_path__ + "media/backgrounds/kym-mackinnon-rG-1gfiQN0k-unsplash-2c6e4055.jpg";